<template>
  <v-container fluid class="pa-0">
    <div class="flex w-full">
      <div v-if="!isMobile || centerV" class="w-full centerCardGradient sm:w-1/2 xs:w-1/2">
        <v-row justify="center" align-content="center" no-gutters>
          <v-col cols="12">
            <div class="flex justify-center">
              <v-avatar tile height="100" width="150" class="my-2">
                <img class="" :src="require('@/assets/img/Logo/logo.gif')" />
              </v-avatar>
            </div>
          </v-col>
          <v-col cols="12" class="overflow-y-auto">
            <NoCompSelected type="setting" v-if="!settingSelector" />
            <component v-else :is="routeSettingLink" />
          </v-col>
        </v-row>
      </div>
      <div class="grid w-full h-screen place-items-center xs:w-1/2 sm:w-1/2 xs:grid" v-if="!isMobile || rightV">
        <div
          class="rounded-none w-full bg-gradient-to-br from-black to-transparent h-screen xs:h-min xs:rounded-[0px_30px_30px_0px]">
          <v-row class="py-7 ma-0 align-end">
            <span class="py-0 pl-10 !w-min">
              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-badge overlap right bottom offset-x="15px" offset-y="20px" :color="colorAsRoute" icon="mdi-help" dark
                    bordered>
                    <v-icon size="50" color="white" v-bind="attrs" v-on="on">
                      mdi-cog-outline
                    </v-icon>
                  </v-badge>
                </template>
                <span :class="`${colorAsRoute}_fortext`">Your settings, FAQs, etc</span>
              </v-tooltip>
            </span>
            <v-col class="py-0 pl-3">
              <h2 class="text-4xl font-Handel">Settings</h2>
            </v-col>
          </v-row>
          <div class="hr2"></div>
          <v-row class="pa-0 ma-0" no-gutters>
            <v-col cols="12" class="pl-5 pr-5 mt-3 overflow-y-auto xs:h-[75vh] h-full">
              <v-list two-line class="text-white transparent font-Nunito">
                <v-list-item dark v-for="(setting, idx) in settings" :key="setting.setting_name" class="mb-5 listBG" :to="{
                  name: setting.link,
                  params: {
                    type: routeLink,
                    setting: setting.setting_name,
                  },
                }" @click.prevent="setCenterView" v-motion :initial="{
  x: 100,
  opacity: 0,
}" :enter="{
  x: 0,
  opacity: 1,
  transition: {
    duration: 300,
    type: 'keyframes',
    ease: 'easeIn',
    delay: `${idx}00`
  },
}">
                  <v-list-item-content>
                    <v-list-item-title class="">{{
                      setting.text
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item dark class="mb-5 listBG" v-if="premium" v-motion :initial="{
                  x: 100,
                  opacity: 0,
                }" :enter="{
  x: 0,
  opacity: 1,
  transition: {
    duration: 300,
    type: 'keyframes',
    ease: 'easeIn',
    delay: `600`
  },
}">
                  <v-list-item-content>
                    <v-list-item-title class=""><template>

                        <v-switch v-model="premiumLayout" @click="changeLayout" class="mt-0" color="primary" dense
                          hide-details label="Switch To Premium Layout"></v-switch>
                      </template></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import NoCompSelected from "../../../../components/noselection/NoCompSelected.vue";
import ProfileSetting from "../../../../components/settings/ProfileSetting.vue";
import FAQ from "../../../../components/settings/FAQ.vue";
import PrivacyPolicy from "../../../../components/settings/PrivacyPolicy.vue";
import ContactUs from "../../../../components/settings/ContactUs.vue";
import { CometChat } from "@cometchat-pro/chat";
import ChangePinCode from "@/components/settings/ChangePinCode.vue";
import PaymentDetails from "@/components/settings/payement_details/PaymentDetails.vue";
import SubscriptionDetail from "@/components/settings/subscription_details/SubscriptionDetail.vue";

export default {
  name: "Settings",
  components: {
    NoCompSelected,
    ProfileSetting,
    FAQ,
    PrivacyPolicy,
    ContactUs,
    ChangePinCode,
    PaymentDetails,
    SubscriptionDetail
  },
  data() {
    return {
      // premiumLayout: false,
      test: '',
      settings: [
        {
          text: "Profile Update",
          setting_name: "ProfileSetting",
          link: "SelectedSetting",
        },
        {
          text: "Change Lock Screen Pin Code",
          setting_name: "ChangePinCode",
          link: "SelectedSetting",
        },
        {
          text: "Payment Details",
          setting_name: "PaymentDetails",
          link: "SelectedSetting",
        },
        {
          text: "Subscription Details",
          setting_name: "SubscriptionDetail",
          link: "SelectedSetting",
        },
        {
          text: "FAQ",
          setting_name: "FAQ",
          link: "SelectedSetting",
        },
        {
          text: "Privacy Policy",
          setting_name: "PrivacyPolicy",
          link: "SelectedSetting",
        },
        {
          text: "Contact Us",
          setting_name: "ContactUs",
          link: "SelectedSetting",
        },

      ],
    };
  },
  computed: {
    getLockPinStatus() {
      return this.$store.getters.StateUser.data.pincode_status;
    },
    colorAsRoute() {
      if (this.routeLink == 'straight') {
        return '#a07a1d'
      }
      else if (this.routeLink == 'gay') {
        return '#88c3fa'
      }
      else if (this.routeLink == 'lesbian') {
        return '#9e2eec'
      }
    },
    settingSelector() {
      return this.$route.params.setting ? true : false;
    },
    routeSettingLink() {
      return this.$route.params.setting;
    },
    premiumLayout() {
      return this.$store.getters.isPremiumLayout
    },
    premium() {
      return this.$store.getters.isPremium
    }
  },
  methods: {

    changeLayout() {
      this.$store.dispatch('premiumLayout' , true);
      this.$router.push({ name: 'Profiles' })
    },




  },



};
</script>

<style scoped>
.listBG {
  background-color: #000000;
  border-radius: 15px;
}

.logo {
  width: 30%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  margin-top: 30px;
  margin-bottom: 30px;
}

.heightAdjuster {
  height: 70vh !important;
}

.chatCardGradient {
  height: 100vh;
  background: rgb(0, 0, 0);
  background: radial-gradient(circle,
      rgba(0, 0, 0, 1) 0%,
      rgba(84, 77, 63, 1) 50%,
      rgba(0, 0, 0, 1) 100%);
}

.straight_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(335deg,
      rgb(136 97 0) 0%,
      rgb(255 223 153) 53%,
      rgb(130 93 0 / 97%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gay_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(357deg,
      rgba(0, 240, 255, 1) 55%,
      rgba(0, 156, 255, 1) 75%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
